const LocationSearchStore = {
    state: () => ({
        selectedPoint:{},
        selectedAddress:{}
    }),
    mutations: {
        setSelectedPoint(state,val){
            state.selectedPoint = val;
        },
        setSelectedAddress(state,val){
            state.selectedAddress = val;
        }
    },
    actions: { },
    getters: {
        getSelectedAddress:function(state){
            return state.selectedAddress;
        },
        getSelectedPoint:function(state){
            return state.selectedPoint;
        }
    }
  } 

export default LocationSearchStore;